export const PAGINATION_SIZE = 5;
export const FIRST_PAGE_SIZE = PAGINATION_SIZE * 2;

export const FOR_YOU_PAGE_SIZE = 3;
